import { FlaskConicalIcon, GlobeIcon, GrapeIcon, HourglassIcon, UtensilsCrossedIcon, WineIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: "Fondamenti del Vino e dell'Enologia",
    summary: "Dall'uva al vino, cosa c'è nel bicchiere, alcol, acidità, tannino e corpo, i grandi stili del vino, vitigno, territorio e clima.",
    icon: WineIcon,
  },
  {
    number: '2',
    title: "Viticoltura: dalla Vite all'Uva",
    summary: 'La pianta della vite, clima e microclima, suoli, il ciclo annuale, maturazione, potatura e forme di allevamento, resa e qualità.',
    icon: GrapeIcon,
  },
  {
    number: '3',
    title: 'Scienza e Produzione del Vino',
    summary: 'Dalla vendemmia alla cantina, lieviti e fermentazione, vinificazione in bianco, in rosso e rosato, metodo classico e Martinotti, vini dolci e fortificati.',
    icon: FlaskConicalIcon,
  },
  {
    number: '4',
    title: 'Affinamento, Invecchiamento e Conservazione',
    summary: 'Ossigeno e tempo, legno, acciaio, cemento e anfora, potenziale di invecchiamento, la cantina ideale, tappi, formati e servizio delle bottiglie vecchie.',
    icon: HourglassIcon,
  },
  {
    number: '5',
    title: 'Analisi Sensoriale, Degustazione e Abbinamento',
    summary: 'Esame visivo, olfattivo e gusto-olfattivo, difetti del vino, degustazione alla cieca, temperatura, calici e servizio, principi di abbinamento cibo-vino.',
    icon: UtensilsCrossedIcon,
  },
  {
    number: '6',
    title: "Regioni, Stili e Storia del Vino: dall'Italia al Mondo",
    summary: 'Storia del vino, le regioni italiane una per una, Francia, Spagna, Portogallo, Germania e Austria, Vecchio e Nuovo Mondo.',
    icon: GlobeIcon,
  },
];
